import { NgModule } from "@angular/core";
import { MaterialModule } from "../../../../../shared/material.module";
import { OpenScapComponent } from "./open-scape.component";
import { QueueTransferPopupComponent } from "./queue-transfer-popup.component";
import { UserTransferPopupComponent } from "./user-transfer-popup.component";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxCountdownModule } from "../ngx-countdown/ngx-countdown.module";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { DropdownModule } from "primeng/dropdown";
import { PopupLoaderModule } from "@app/shared";
import { callBackCustomerListModalComponent } from "../../lead-notes/callback-customers-list-popup.component";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { callBackCustomerInfoModalComponent } from "../../lead-notes/callback-customers-info-popup.component";
@NgModule({
  declarations: [OpenScapComponent, QueueTransferPopupComponent, UserTransferPopupComponent,callBackCustomerListModalComponent,
    callBackCustomerInfoModalComponent],
  imports: [
    MaterialModule,CommonModule,FormsModule,ReactiveFormsModule,NgxCountdownModule,InfiniteScrollModule,DropdownModule,
    PopupLoaderModule,ScrollPanelModule
  ],
  exports: [OpenScapComponent],
  entryComponents: [QueueTransferPopupComponent,
    UserTransferPopupComponent,callBackCustomerListModalComponent,callBackCustomerInfoModalComponent],
})
export class OpenscapeModule { }